module.exports = require("debug");


//////////////////
// WEBPACK FOOTER
// external "debug"
// module id = 8
// module chunks = 0